import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
export var SignupAccountSchema = new SimpleSchema({
    email: {
        type: String,
        regEx: SimpleSchema.RegEx.Email
    },
    password: {
        type: String,
        min: 10
    }
});
export var NewPasswordSchema = new SimpleSchema({
    password: {
        type: String,
        min: 10
    },
    // @ts-ignore
    confirmPassword: {
        type: String,
        custom: function custom() {
            return this.value !== this.field("password").value && "passwordMismatch";
        }
    }
});
